/**
 * Calculates the straight-line distance between two points. If the second point includes `width` and/or `height`,
 * it treats it as a rectangular area and adjusts the center point accordingly.
 *
 * @param {Point} p1 - The first point.
 * @param {Point & { width?: number; height?: number }} p2 - The second point, optionally including width and height to adjust the center.
 * @returns {number} The calculated distance between the two points.
 */
export function measureDistance(p1, p2) {
    let p2y = p2.y;
    let p2x = p2.x;
    if (p2.width != null) {
        p2x += p2.width / 2;
    }
    if (p2.height != null) {
        p2y += p2.height / 2;
    }
    return Math.sqrt(Math.pow(p2x - p1.x, 2) + Math.pow(p2y - p1.y, 2));
}
